<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <!-- Title -->
          <span class="sub-item">Home </span>
          <h2 class="ui primary header">Contact Us</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
  </div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="30px">
    <div fxFlex="grow">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
        <esl-message-toast
          [(message)]="success"
          [messageType]="'success'"
        ></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
      <form class="ui form" [formGroup]="detailForm">
        <div
          class="required field topic"
          [ngClass]="displayFieldCss('topicId')"
        >
          <label class="bold"
            >Which of these services would you like to enquire about?</label
          >
          <div class="grouped fields">
            <div
              appMargin
              marginB="1"
              class="field required"
              *ngFor="let optionx of topics"
            >
              <div>
                <label>
                  <input
                    (change)="getSubtopics(optionx.topicId)"
                    type="radio"
                    formControlName="topicId"
                    [value]="optionx.topicId"
                  />
                  {{ optionx.topic }}
                </label>
              </div>
            </div>
            <app-field-error-display
              [displayError]="isFieldValid('topicId')"
              errorMsg="Please select a service"
            >
            </app-field-error-display>
          </div>
        </div>
        <!-- Only expand if user has selected a service -->
        <div [suiCollapse]="!detailForm.controls['topicId'].value">
          <div
            class="required field subtopic"
            [ngClass]="displayFieldCss('subtopicId')"
          >
            <label class="bold"
              >Which of these sub-service would you like to enquire
              about?</label
            >
            <div class="grouped fields">
              <div
                appMargin
                marginB="1"
                class="field required"
                *ngFor="let optionx of subtopics"
              >
                <div>
                  <label>
                    <input
                      type="radio"
                      formControlName="subtopicId"
                      [value]="optionx.subtopicId"
                    />
                    {{ optionx.subtopic }}
                  </label>
                </div>
              </div>
              <div class="field" *ngIf="subtopics?.length < 1">
                <p>There is no Sub services under this service</p>
              </div>
              <app-field-error-display
                [displayError]="isFieldValid('subtopicId')"
                errorMsg="Please select a sub service"
              >
              </app-field-error-display>
            </div>
          </div>
        </div>

        <div [suiCollapse]="!detailForm.controls['subtopicId'].value">
          <div class="required field more">
            <label class="bold"
              >Please fill the message below to explain the issue you are
              facing.</label
            >
          </div>
          <div class="required field" [ngClass]="displayFieldCss('name')">
            <label>Name </label>
            <input #input type="text" name="name" formControlName="name" />
            <app-field-error-display
              [displayError]="isFieldValid('name')"
              errorMsg="Please fill"
            >
            </app-field-error-display>
          </div>
          <div class="required field" [ngClass]="displayFieldCss('email')">
            <label>Email </label>
            <input type="email" name="email" formControlName="email" />
            <app-field-error-display
              [displayError]="isFieldValid('email')"
              errorMsg="Please fill"
            >
            </app-field-error-display>
          </div>

          <div class="required field">
            <label>Phone Number </label>
            <input
              type="text"
              name="phone"
              formControlName="phone"
              [ngClass]="displayFieldCss('phone')"
            />
            <app-field-error-display
              [displayError]="isFieldValid('phone')"
              errorMsg="Please fill"
            >
            </app-field-error-display>
          </div>

          <div class="required field">
            <label>Subject </label>
            <input
              type="text"
              name="subject"
              formControlName="subject"
              [ngClass]="displayFieldCss('subject')"
            />
            <app-field-error-display
              [displayError]="isFieldValid('subject')"
              errorMsg="Please fill"
            >
            </app-field-error-display>
          </div>

          <div class="required field" [ngClass]="displayFieldCss('message')">
            <label>Message</label>
            <textarea formControlName="message"></textarea>
            <app-field-error-display
              [displayError]="isFieldValid('message')"
              errorMsg="Please fill"
            >
            </app-field-error-display>
          </div>
          <div class="field required" [ngClass]="displayFieldCss('captcha')">
            <re-captcha
              #captchaRef="reCaptcha"
              formControlName="captcha"
            ></re-captcha>
            <app-field-error-display
              [displayError]="isFieldValid('captcha')"
              errorMsg="Please confirm you are not a robot"
            >
            </app-field-error-display>
          </div>

          <button
            class="ui primary button"
            [ngClass]="{ 'yellow loading': loading }"
            (click)="send()"
            [disabled]="!detailForm.valid || loading"
          >
            Send
          </button>
        </div>
      </form>
    </div>

    <div fxFlex="30%" fxFlex.lt-sm="100%">
      <div appPadding="7" class="side" [innerHtml]="contactDetails"></div>
    </div>
  </div>
</div>
